import axios from '../../v2/app/services/axiosService';

/**
 * MLD-1975
 */
export default {
  /**
   * Generate the QR code and prompt the user to enter the code from an app.
   * @returns {Promise<{data: *}>}
   */
  async generate() {
    const {data} = await axios.get(`/api/mfa/generate`);
    return data;
  },
  /**
   * After entering the code,
   * @returns {Promise<{data: *}>}
   * @param {string} key
   * @param {string} code
   */
  async configure(key, code) {
    const form = {
      key,
      code,
    }
    const {data} = await axios.post(`/api/mfa/configure`, form);
    return data;
  },
  async enable() {
    const {data} = await axios.post(`/api/mfa/enable`);
    return data;
  },
  async disable(code) {
    const form = {
      code,
    }
    const {data} = await axios.post(`/api/mfa/disable`, form);
    return data;
  },
  async getLoginSecurity() {
    const {data} = await axios.get(`/api/mfa/login-security`)
    return data;
  }
}
